import Vue from 'vue';
import App from './App.vue';
import '../sso_common/env';
import { disableScaleInMobile } from '@/sso_common/head';
import '../sso_common/i18n';

disableScaleInMobile();
new Vue({
  el: '#app',
  render: h => h(App),
});
